import { render } from "./NurseDetailsModal.vue?vue&type=template&id=2f51638e"
import script from "./NurseDetailsModal.vue?vue&type=script&lang=js"
export * from "./NurseDetailsModal.vue?vue&type=script&lang=js"

import "./NurseDetailsModal.vue?vue&type=style&index=0&id=2f51638e&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__